import { PermissionGroup } from '~/gql/ucc/graphql';
import { PermissionGroup as PermissionGroupType } from '../components/types';

/**
 * Vereinigt statische Config (inkl. dynamischer Niederlassungen) mit den gespeicherten
 * permissionGroups einer Rolle aus der API.
 */
export function mergePermissionGroupsFromRemote(
    config: PermissionGroupType[],
    remote: PermissionGroup[]
): PermissionGroup[] {
    return Object.values(
        (config ?? []).reduce<Record<string, PermissionGroupType>>((acc, group) => {
            const remoteGroup = remote.find((r) => r.id === group.id);
            const remoteGroupResources = remoteGroup?.resources || [];
            const resources = (group.resources ?? []).reduce<Record<string, any>>((resourceAcc, resource) => {
                const resourceMatch = remoteGroupResources.find(
                    (remoteResource: { id: string }) => remoteResource.id === resource.id
                );

                return {
                    ...resourceAcc,
                    [resource.id]: resourceMatch ? { ...resourceMatch, name: resource.name } : resource,
                };
            }, {});

            return {
                ...acc,
                [group.id]: remoteGroup
                    ? {
                          ...remoteGroup,
                          name: group.name,
                          resources: Object.values(resources),
                      }
                    : group,
            };
        }, {})
    ) as unknown as PermissionGroup[];
}
